module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_8.0f95bb1c.png";